import { DemandSecureEntityIdPrefix } from "./DemandSecureEntity";

export type GatewayCredentialsId =
    `${DemandSecureEntityIdPrefix.GatewayCredentials}-${string}`;
